export interface UserInfo {
  firstName: string;
  lastName: string;
}

export interface User {
  email?: string;
  email_verified?: string;
  logins_count?: number;
  name?: string;
  user_id: string;
  status?: string;
  roles?: string[];
  disabled?: boolean;
}

export interface Role {
  name: string;
  applicationId: string;
  description: string;
}

export enum SetupState {
  needsPassword = 'password',
  needsMfa = 'mfa',
  complete = 'complete',
  completeImaUser = 'completeImaUser',
  completedPassword = 'completedPassword',
  completedMfa = 'completedMfa'
}
